<template>
  <div>
   <el-dialog
      title
      top="9vh"
      :visible.sync="dialogTopic"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px">
      <div class="dialogUL">
        <ul
          v-for="(item, idx) in examContentData"
          :key="idx"
          v-if="idx == numIdx">
          <h3 class="dialogUL_h3">
            {{ idx + 1 }}.{{ item.content }}(&nbsp;&nbsp;&nbsp;&nbsp;)
          </h3>
          <li v-if="item.url" class="imgList">
            <img :src="urlImg + item.url" />
            <!-- <h3>如图所示</h3> -->
          </li>
          <div class="rigCen">
            <li
              v-for="(optionList, i) in item.optionTOList"
              :key="i"
              :class="optionList.code == item.type_hove ? 'rigCenhov' : ''"
              @click="parsingFun(optionList, item)"
            >
              <h3>{{ optionList.code }}、{{ optionList.content }}</h3>
            </li>
          </div>
          <div class="ellipsis diacen">
            <el-button type="primary" @click="sumBtn(item)" :disabled="item.type_hove==''">确定</el-button>
          </div>
        </ul>
      </div>
    </el-dialog>
    <el-dialog
      title
      top="9vh"
      :show-close="false"
      :visible.sync="answerType"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px">
      <div class="answer">
        <div class="is_correct">
          <span class="is_correct_font" :class="correct.is_correct=='False'?'red':'green'">
            {{correct.is_correct=='False'?'×':'✔'}} 
          </span>
        </div>
        <div class="answerCen">
          <h3 v-if="correct.answer"> 答案：{{correct.answer.code}}</h3>
          <h3 class="h3"> 答案解析：{{ correct.parsing }}</h3>
          <div class="sumcen">
            <el-button type="primary" @click="submit">确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    // 列表数据
    initData:{
      type: Array,
      required: true
    },
    // 是否弹窗
     dialog: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      routerType: 1,
      dialogTopic: false,
      answerType: false, // 答案解析
      parsing: [],
      listData: [],
      examContentData: [],
      numData: 0, // 题目数量
      numIdx: 0, // 当前题目
      urlImg: process.env.VUE_APP_HUBEI+'/',
      correct: {},    // 选择数据
      homeSubmit:[],
      topicCode:{},
      tempTopicArr:[],  // 对接国家虚仿平台，放置
    };
  },
  methods: { 
    reset(){
      this.routerType = 1;
      this.dialogTopic =  false;
      this.answerType= false; // 答案解析
      this.parsing= [];
      this.listData= [];
      this.examContentData= [];
      this.numData= 0; // 题目数量
      this.numIdx= 0; // 当前题目
      this.correct= {};    // 选择数据
      this.homeSubmit=[];
      this.tempTopicArr = [];
    },
    // 题目解析确认
    submit(){
      this.answerType = false;
      this.numIdx = this.homeSubmit.length;
      let objAttr = [];
      this.tempTopicArr.push(this.topicCode);
       if (sessionStorage.getItem("topicCode")) {
           objAttr = JSON.parse(sessionStorage.getItem("topicCode"));
          if (objAttr.filter(list=>list.topic_code== this.topicCode.topic_code).length == 0) {
            objAttr.push(this.topicCode);
             sessionStorage.setItem("topicCode", JSON.stringify(objAttr));
          }else{
             objAttr.filter(list=>list.topic_code== this.topicCode.topic_code)[0].code = this.topicCode.code;
             objAttr.filter(list=>list.topic_code== this.topicCode.topic_code)[0].content = this.topicCode.content;
             objAttr.filter(list=>list.topic_code== this.topicCode.topic_code)[0].is_correct = this.topicCode.is_correct;
             objAttr.filter(list=>list.topic_code== this.topicCode.topic_code)[0].topic_code = this.topicCode.topic_code;
             sessionStorage.setItem("topicCode", JSON.stringify(objAttr));
          }
        } else {
          let objAttr = [];
          objAttr.push(this.topicCode);
          sessionStorage.setItem("topicCode", JSON.stringify(objAttr));
        }
      if(this.numIdx>=this.numData){
        // this.dialogTopic = false;
        // this.reset();
        this.dialogTopic =  false;
        this.answerType = false;
        this.$emit('getSucceed', this.tempTopicArr)
      }
    },
    parsingFun(item, idx) {
      this.correct = {
        is_correct: item.is_correct,
        parsing: idx.parsing,
        answer: idx.optionTOList.filter(items=>items.is_correct=='True')[0]
      };
      idx.type_hove = item.code;
      this.homeSubmit.push(this.correct);
      this.topicCode = item;    // 记录到缓存
    },
    // 确定是否正确
    sumBtn(item) {
      // if(this.correct=='False'){

      // }
      this.answerType = true;
    },
    init(){
      this.examContentData = this.initData;
      this.dialogTopic= this.dialog;
      this.numData= this.initData.length;
      console.log("this.examContentData", this.examContentData);
    }
  },
  mounted() {
  },
  created() {}
};
</script>
<style lang="less" scoped>
// 题目
.dialogUL {
  white-space: normal;
  margin-top: 10px;
  ul {
    clear: both;
    overflow: hidden;
    .dialogUL_h3 {
      margin-bottom: 10px;
      font-size: 16px;
    }
    li {
      line-height: 20px;
      margin: 10px;
      border-radius: 10px;
      padding: 10px 30px;
      cursor: pointer;
      -webkit-box-shadow: 0 0 4px 0 #83bdfb;
      box-shadow: 0 0 4px 0 #83bdfb;
      margin-bottom: 20px;
    }
    .imgList {
      border: none;
      clear: both;
      overflow: hidden;
      text-align: center;
      -webkit-box-shadow: 0 0 4px 0 #83bdfb;
      box-shadow: 0 0 4px 0 #464646;
      margin: 20px;
      img {
        height: 305px;
      }
    }
  }
  .rigCen {
    li {
      transition: all 0.5s;
    }
  }
  .rigCen li:hover {
    background: #83bdfb;
    color: #fff;
    // transform: scale(1.05);
  }
  .rigCenhov {
    background: #83bdfb;
    color: #fff;
  }
  .diacen {
    text-align: center;
    margin-bottom: 20px;
  }
}
// 答案解析
.answer {
 .is_correct{
       text-align: center;
    margin-bottom: 20px;
   .is_correct_font{
          text-align: center;
          display: inline-block;
          width: 100px;
          height: 100px;
          border-radius: 50%;
          line-height: 100px;
          font-size: 70px;
          color: #fff;
   }
 }
  .answerCen {
    padding-bottom: 20px;
     h3 {
        font-size: 22px;
        text-align: center;
        text-align: left;
      }
    .h3{
        font-size: 16px;
        margin-top: 10px;
        text-align: left;
    }
    .sumcen{
        text-align: center;
        margin-top: 20px;
    }
  }
}
.green{
  background: #00ab25;
}
.red{
  background: red;
}
</style>
